<template>
  <el-dialog
    v-if="visible"
    style="overflow-y: auto"
    :title="title"
    visible
    :width="width ? width : ''"
    :close-on-click-modal="closeOnClickModal"
    :append-to-body="appendToBody"
    :show-close="showClose"
    :fullscreen="fullscreen"
    :destroy-on-close="destroyOnClose"
    :custom-class="customClass"
    @opened="open"
    @close="close"
  >
    <div v-if="showHeader" slot="title" class="flex">
      <!-- <slot name="header"> -->
      <base-icon icon-name="cube2" size="16"></base-icon>
      {{ title }}
      <!-- </slot> -->
    </div>
    <slot />
    <footer v-if="showFooter" slot="footer">
      <slot name="footer" />
      <el-button v-if="showSubmit" type="primary" @click="submit">
        {{ submitTxt }}
      </el-button>
      <el-button v-if="showClose" class="close-btn" @click="close">
        {{ cancelTxt }}
      </el-button>
    </footer>
  </el-dialog>
</template>
<script>
import BaseIcon from "@/components/svgIcon/index.vue";
export default {
  name: "BaseDialog",
  components: { BaseIcon },
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: () => "",
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: () => "",
    },
    submitText: {
      type: String,
      default: () => "",
    },
    width: {
      type: String,
      default: () => "",
    },
    closeOnClickModal: {
      type: Boolean,
      default: () => false,
    },
    appendToBody: {
      type: Boolean,
      default: () => true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    destroyOnClose: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    cancelTxt: function () {
      return this.cancelText ? this.cancelText : this.$t("cancel");
    },
    submitTxt: function () {
      return this.submitText ? this.submitText : this.$t("commitText");
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    open() {
      this.$emit("open");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style  scoped>
::v-deep .el-dialog__body{
  padding-top: 0;
}
::v-deep .el-dialog__header {
  font-weight: bold;
}
.flex {
  display: flex;
  align-items: center;
  color: #262626;
  font-size: 14px;
  font-weight: bold;
}
</style>
